import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function DeleteConfirm({ open, onOpenChange, onConfirm, title }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="delete-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">
            Eliminare questa scheda?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Stai per eliminare{" "}
            <span className="font-medium text-zinc-800">
              "{title || "questa risorsa"}"
            </span>
            . L'operazione è irreversibile.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction
            data-testid="delete-confirm-btn"
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Elimina
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
